import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function   Mumbaitosolapurcab() {



  const cardData = {
    keyword: " Mumbai to Solapur Cab",


"headingDescription": "Royal Route Cab offers reliable Mumbai to Solapur cab service, providing safe, comfortable, and affordable long-distance travel for families, corporate travelers, students, and group journeys. Solapur is an important city in Maharashtra located approximately 400 km from Mumbai and is well connected via smooth national highways, making it a convenient road trip destination. Our professional drivers ensure a safe, punctual, and stress-free journey with door-to-door pickup and drop service, proper rest stops, and comfortable travel experience. We offer flexible options including one-way drops, round trips, and customized travel plans. Our fleet includes economy sedans, premium sedans, SUVs, Innova, Ertiga, Innova Crysta, and Tempo Travellers suitable for all group sizes. With transparent pricing, 24/7 availability, and easy booking, Royal Route Cab is your trusted choice for Mumbai to Solapur cab service.",

"topPlaces": [
  {
    "title": "Siddheshwar Temple",
    "description": "Siddheshwar Temple is the most famous religious site in Solapur dedicated to Lord Shiva and Lord Siddheshwar. Located near a beautiful lake, it attracts thousands of devotees every year. The temple complex is known for its spiritual atmosphere, religious festivals, and peaceful surroundings, making it a key destination for pilgrims traveling from Mumbai."
  },
  {
    "title": "Great Indian Bustard Sanctuary (Nannaj)",
    "description": "Located near Solapur, this sanctuary is one of the last habitats of the critically endangered Great Indian Bustard. It is a significant wildlife conservation area offering birdwatching and nature exploration opportunities for eco-tourists."
  },
  {
    "title": "Bhui-Kot Fort",
    "description": "Bhui-Kot Fort is a historic fort in Solapur showcasing medieval architecture and local history. It offers insights into the region’s past and is a popular spot for heritage enthusiasts visiting the city."
  },
  {
    "title": "Hutatma Smarak",
    "description": "Hutatma Smarak is a memorial dedicated to the martyrs of the Samyukta Maharashtra movement. It stands as a symbol of pride and sacrifice and is an important historical landmark in Solapur."
  },
  {
    "title": "Hipparga Lake",
    "description": "Hipparga Lake is a peaceful waterbody near Solapur offering scenic views and relaxation opportunities. It is a popular spot for evening outings and short nature breaks within the city."
  },
  {
    "title": "Shri Swami Samarth Temple Akkalkot (Nearby)",
    "description": "Located near Solapur, Akkalkot is a major pilgrimage site dedicated to Shri Swami Samarth Maharaj. Many travelers combine Solapur trips with Akkalkot darshan for a complete spiritual journey."
  },
  {
    "title": "Solapur Textile Market",
    "description": "Solapur is famous for its textile industry, especially bedsheets and towels. The local textile market is a bustling commercial hub where visitors can experience regional trade and shopping culture."
  },
  {
    "title": "Siddheshwar Lake",
    "description": "Siddheshwar Lake surrounds the famous Siddheshwar Temple and adds scenic beauty to the area. It is a peaceful spot for walking, relaxation, and enjoying natural surroundings."
  },
  {
    "title": "Akkalkot Math",
    "description": "Akkalkot Math is a sacred spiritual center dedicated to Shri Swami Samarth Maharaj. It is a calm and devotional place attracting pilgrims from across Maharashtra and India."
  },
  {
    "title": "Kambar Talav",
    "description": "Kambar Talav is a local lake in Solapur known for its serene environment and evening views. It is a simple yet peaceful attraction for short leisure visits."
  }
],






services: [
  {
    name: "Mumbai to Solapur Cab",
    description: "Mumbai to Solapur cab service offers a comfortable and reliable long-distance journey across Maharashtra. Ideal for business travelers, families, and pilgrims, this service ensures smooth highway travel with experienced drivers. Well-maintained vehicles enhance comfort. It guarantees a safe and hassle-free travel experience."
  },
  {
    name: "Mumbai to Solapur Taxi",
    description: "Mumbai to Solapur taxi provides private and convenient intercity travel with flexible schedules. This service includes door-to-door pickup and comfortable seating. Suitable for long-distance journeys. It ensures a smooth and reliable ride."
  },
  {
    name: "Mumbai to Solapur Cab Service",
    description: "Mumbai to Solapur cab service offers professional travel solutions with multiple vehicle options. This service is ideal for family trips, business travel, and group journeys. Clean vehicles and trained drivers ensure comfort. It ensures a dependable travel experience."
  },
  {
    name: "Mumbai to Solapur Taxi Service",
    description: "Mumbai to Solapur taxi service ensures dependable transportation for long-distance travel. This service is suitable for both business and personal trips. Flexible booking options make travel convenient. It guarantees a pleasant journey."
  },
  {
    name: "Cab from Mumbai to Solapur",
    description: "Cab from Mumbai to Solapur offers a convenient way to travel between cities with complete comfort. This service is ideal for those preferring road travel. Professional drivers ensure safe journeys. It ensures a relaxed experience."
  },
  {
    name: "Taxi from Mumbai to Solapur",
    description: "Taxi from Mumbai to Solapur provides reliable long-distance travel for individuals and groups. This service ensures smooth highway journeys with experienced drivers. Comfortable seating enhances the experience. It guarantees a dependable ride."
  },
  {
    name: "Mumbai to Solapur Cab Booking",
    description: "Mumbai to Solapur cab booking allows customers to reserve their ride easily with flexible options. Travelers can choose vehicle type, pickup location, and timing. Instant confirmation ensures availability. It simplifies travel planning."
  },
  {
    name: "Mumbai to Solapur Taxi Booking Online",
    description: "Mumbai to Solapur taxi booking online provides a quick and convenient way to plan your journey. Customers can compare vehicles and pricing easily. Secure payment and instant confirmation enhance convenience. It ensures hassle-free booking."
  },
  {
    name: "Mumbai to Solapur Cab Price",
    description: "Mumbai to Solapur cab price varies based on vehicle type, distance, and trip duration. Transparent pricing ensures no hidden charges. Customers can choose from budget and premium options. It helps in planning travel expenses efficiently."
  },
  {
    name: "Mumbai to Solapur Taxi Fare",
    description: "Mumbai to Solapur taxi fare is designed to be competitive for long-distance travel. Fare depends on route and vehicle selection. Customers receive clear pricing details before booking. It ensures cost-effective travel."
  },
  {
    name: "Mumbai to Solapur One Way Cab",
    description: "Mumbai to Solapur one way cab offers cost-effective travel without return charges. This service is ideal for single-side journeys. Flexible pickup options enhance convenience. It ensures smooth and economical travel."
  },
  {
    name: "Mumbai to Solapur Round Trip Taxi",
    description: "Mumbai to Solapur round trip taxi provides complete travel solutions including return journeys. This service is ideal for business trips and vacations. Flexible schedules and comfortable vehicles enhance convenience. It ensures a hassle-free experience."
  },
  {
    name: "Mumbai to Solapur Innova Cab",
    description: "Mumbai to Solapur Innova cab is perfect for families and groups seeking spacious and comfortable travel. Premium seating and smooth performance enhance long journeys. It ensures a comfortable intercity experience."
  },
  {
    name: "Mumbai to Solapur Ertiga Cab",
    description: "Mumbai to Solapur Ertiga cab offers affordable and spacious travel for small groups and families. Comfortable seating and good mileage make it ideal for long-distance journeys. It ensures a pleasant trip."
  },
  {
    name: "Mumbai to Solapur Sedan Cab",
    description: "Mumbai to Solapur sedan cab is ideal for individuals and small families seeking economical travel. Sedans offer smooth rides and comfort for long journeys. Professional drivers ensure safety. It ensures a relaxed journey."
  },
  {
    name: "Mumbai to Solapur SUV Taxi",
    description: "Mumbai to Solapur SUV taxi provides spacious and comfortable travel for groups. SUVs offer better performance and extra luggage space. Suitable for long-distance journeys. It ensures a comfortable travel experience."
  },
  {
    name: "Cheap Mumbai to Solapur Cab",
    description: "Cheap Mumbai to Solapur cab offers budget-friendly travel options without compromising comfort and safety. This service is ideal for cost-conscious travelers. Transparent pricing ensures no hidden charges. It ensures economical travel."
  },
  {
    name: "Best Mumbai to Solapur Taxi Service",
    description: "Best Mumbai to Solapur taxi service ensures top-quality vehicles, professional drivers, and excellent customer support. This service focuses on comfort, safety, and punctuality. It guarantees a reliable and premium journey."
  }
],

tableData: [
  ["Mumbai to Solapur Cab", "Mumbai to Solapur Taxi"],
  ["Mumbai to Solapur Cab Service", "Mumbai to Solapur Taxi Service"],
  ["Cab from Mumbai to Solapur", "Taxi from Mumbai to Solapur"],
  ["Mumbai to Solapur Cab Booking", "Mumbai to Solapur Taxi Booking Online"],
  ["Mumbai to Solapur Cab Price", "Mumbai to Solapur Taxi Fare"],
  ["Mumbai to Solapur One Way Cab", "Mumbai to Solapur Round Trip Taxi"],
  ["Mumbai to Solapur Innova Cab", "Mumbai to Solapur Ertiga Cab"],
  ["Mumbai to Solapur Sedan Cab", "Mumbai to Solapur SUV Taxi"],
  ["Cheap Mumbai to Solapur Cab", "Best Mumbai to Solapur Taxi Service"]
],


whychoose: [
  {
    WhyChooseheading: "Comfortable Mumbai to Solapur Travel",
    WhyChoosedescription: "Royal Route Cabs offers a smooth and comfortable Mumbai to Solapur cab service, ideal for family trips, business travel, and religious visits."
  },
  {
    WhyChooseheading: "Experienced Highway Drivers",
    WhyChoosedescription: "Our drivers are highly experienced in long-distance routes, ensuring safe driving, smooth navigation, and timely arrival."
  },
  {
    WhyChooseheading: "Ideal for Business & Pilgrimage Trips",
    WhyChoosedescription: "Whether visiting Solapur for business, family, or temple darshan, our cab service ensures a hassle-free journey."
  },
  {
    WhyChooseheading: "Transparent Pricing with No Hidden Charges",
    WhyChoosedescription: "Royal Route Cabs provides clear and upfront pricing including tolls, driver allowance, and all travel costs with no hidden charges."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "Choose from one-way cab service, round-trip bookings, or multi-day travel plans for Solapur trips."
  },
  {
    WhyChooseheading: "24/7 Cab Service Availability",
    WhyChoosedescription: "Our Mumbai to Solapur cab service operates 24/7, allowing flexible departure anytime as per your schedule."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "We offer sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, Tempo Travellers, and mini buses for group travel."
  },
  {
    WhyChooseheading: "Trusted Intercity Cab Service",
    WhyChoosedescription: "Royal Route Cabs is trusted by travelers for Mumbai to Solapur cab bookings due to reliable service and professional drivers."
  }
]

};

const faqData = [
  { question: "Do you provide Mumbai to Solapur cab service?", answer: "Yes, Royal Route Cabs offers reliable cab services from Mumbai to Solapur for one-way and round trips." },
  { question: "What is the distance between Mumbai and Solapur?", answer: "The distance is approximately 400 to 450 km and takes around 8 to 10 hours depending on route and traffic." },
  { question: "Is cab service available 24 hours?", answer: "Yes, our Mumbai to Solapur cab service operates 24/7." },
  { question: "Which vehicles are available for this route?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, Innova Crysta, Tempo Travellers, and mini buses." },
  { question: "Can I book a one-way cab?", answer: "Yes, we provide both one-way and round-trip cab services." },
  { question: "Is this suitable for family travel?", answer: "Yes, our service is ideal for family, business, and group travel." },
  { question: "Do you provide interstate travel permits?", answer: "Yes, all required permits are arranged for smooth travel." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended for long-distance travel." },
  { question: "Do you provide doorstep pickup?", answer: "Yes, we provide pickup from home, hotel, and office anywhere in Mumbai." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly for passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Avinash Patil",
    feedback: "The Mumbai to Solapur cab ride with Royal Route Cabs was very comfortable and smooth. The highway journey felt safe and well-managed throughout.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Pooja Deshmukh",
    feedback: "Excellent experience traveling from Mumbai to Solapur. The cab was clean, the driver was professional, and the trip was hassle-free and relaxing.",
    rating: 5
  }
];









  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman taxi", link: "Mumbai-to-Daman-Taxi" },
    { place: "/images/keyword/26.jpg", text: "Mumbai to Vapi cab", link: "Mumbai-to-Vapi-Cab" },
    { place: "/images/keyword/27.jpg", text: "Mumbai to Bangalore cab", link: "Mumbai-to-Bangalore-Cab" }
  ];





const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Solapur Cab",
  "image": "https://www.royalroutecabs.com/assets/images/mumbai-to-solapur-cab.jpg", // replace if needed
  "description": "Book Mumbai to Solapur cab service with Royal Route Cabs for safe, reliable, and comfortable intercity travel. Available for one-way and round-trip journeys with sedan, SUV, Innova, and Ertiga vehicles. 24x7 outstation taxi service at affordable rates.",
  "brand": {
    "@type": "Brand",
    "name": "Royal Route Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "ratingCount": "3200",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "8999", // approx starting fare (adjust if needed)
    "availability": "https://schema.org/InStock",
    "url": "https://www.royalroutecabs.com/mumbai-to-solapur-cab"
  }
};









  return (
    <div>
<Helmet>
  <title>Mumbai to Solapur Cab | Call:- +91 9529877342 | Best Outstation Cab Service</title>

  <meta
    name="description"
    content="Book Mumbai to Solapur cab with Royal Route Cabs. Safe, affordable, and comfortable outstation taxi service with sedan, SUV, Innova & Ertiga cars. 24x7 reliable travel."
  />

  <meta
    name="keywords"
    content="mumbai to solapur cab, mumbai to solapur taxi, mumbai to solapur cab service, mumbai to solapur taxi service, cab from mumbai to solapur, taxi from mumbai to solapur, mumbai to solapur cab booking, mumbai to solapur taxi booking online, mumbai to solapur cab price, mumbai to solapur taxi fare, mumbai to solapur one way cab, mumbai to solapur round trip taxi, mumbai to solapur innova cab, mumbai to solapur ertiga cab, mumbai to solapur sedan cab, mumbai to solapur suv taxi, cheap mumbai to solapur cab, best mumbai to solapur taxi service"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div
        className="breadcrumb-wrapper section-padding bg-cover"
        style={{ backgroundImage: "url('/img/breadcrumb-bg.jpeg')" }}
      >
        <div className="container-fluid">
          <div className="page-heading">
            <h1 className="text-center">{cardData.keyword}</h1>
          </div>
        </div>
      </div>














      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/60.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Royal Route Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


          <div className="keyword-grid">
  {cardData.tableData.flat().map((keyword, index) => (
    <div key={index} className="keyword-item">
      <span className="keyword-bullet">-</span>
      {keyword}
    </div>
  ))}
</div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title text-white">
                  Why Choose <span>Royal Route Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Royal Route Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529877342" className="pc-call">+91 9529877342</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529877342"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529877342" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@royalroutecabs.com" className="pc-email">
                      booking@royalroutecabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Royal Route Cab</strong><br />
                      Shop Number 57, Prabhat Colony Opp. Panbai International School Vimladevi Road,Santacruz(E) Mumbai Maharashtra-400055.


                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitosolapurcab;